module.exports = __webpack_public_path__ + "assets/img/cooperative-partner.512704ec.png";